import { render } from "./ToggleTriggerButtons.vue?vue&type=template&id=28cfe35c"
import script from "./ToggleTriggerButtons.vue?vue&type=script&lang=js"
export * from "./ToggleTriggerButtons.vue?vue&type=script&lang=js"
script.render = render

export default script